<ng-template #displayMessage let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Attention!</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeMessageModal(); modal.close()" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngFor="let message of messages">{{message}}</p>
  </div>
  <div class="modal-footer">
    &nbsp;&nbsp;
    <button
      type="button"
      class="btn btn-primary"
      mat-flat-button
      (click)="closeMessageModal();modal.close()"
      >
      Ok
    </button>
  </div>
</ng-template>

<ng-template #tabDisplayMssage let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Attention!</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeMessageModal(true); modal.close()" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngFor="let message of tabSpecificMessages[currentTabIndex]">{{message}}</p>
  </div>
  <div class="modal-footer">
    &nbsp;&nbsp;
    <button
      type="button"
      class="btn btn-primary"
      mat-flat-button
      (click)="closeMessageModal(true);modal.close()"
      >
      Ok
    </button>
  </div>
</ng-template>

<ng-template
  #actions
  let-row="row"
  let-rowIndex="rowIndex"
  let-currentPage="currentPage"
  let-pageSize="pageSize"
  let-reportId="reportId"
  let-tableId="tableId"
>
  <!-- Wrapper changes based on mode -->
  <div
    class="action-box d-flex w-100"
    *ngIf="!isActionsCollapsed(reportId)"
  >
    <ng-container
      *ngTemplateOutlet="actionsButton; context: { row: row, rowIndex: rowIndex, currentPage: currentPage, pageSize: pageSize }"
    ></ng-container>
  </div>

  <ng-template #actionsButton let-row="row" let-rowIndex="rowIndex" let-currentPage="currentPage" let-pageSize="pageSize">
    <!-- View -->
    <ng-container *ngIf="isInViewMode; else viewModeTemplate">
      <ng-container *ngIf="isProcessReport(reportId) && row.process_actor_ui_type == 1; else viewAsLink">
        <button
          *ngIf="isViewIconVisible(tableId)"
          type="button"
          class="action-button action-button-view"
          [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
          view-rid="${row.id}"
          tabindex="isViewIconVisible(tableId) ? 0 : -1"
          (click)="viewRow($event, row, tableId, reportId)"
        >
          View
        </button>
      </ng-container>
      <ng-template #viewAsLink>
        <a
          #viewLink
          *ngIf="isViewIconVisible(tableId)"
          class="action-button action-button-view"
          [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
          view-rid="${row.id}"
          tabindex="isViewIconVisible(tableId) ? 0 : -1"
          [routerLink]="getViewLink(row, tableId, reportId)"
          (keydown.space)="$event.preventDefault(); viewLink.click()"
        >
          View
        </a>
      </ng-template>
    </ng-container>
    <ng-template #viewModeTemplate>
      <a
        #viewModeLink
        *ngIf="isViewIconVisible(tableId)"
        class="action-button action-button-view"
        [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
        view-rid="${row.id}"
        tabindex="isViewIconVisible(tableId) ? 0 : -1"
        [href]="getViewLink(row, tableId, reportId, false)"
        (click)="viewRow($event, row, tableId, reportId)"
        (keydown.space)="$event.preventDefault(); viewModeLink.click()"
      >
        View
      </a>
    </ng-template>

    <!-- Edit -->
    <a
      #editLink
      *ngIf="isEditIconVisible(row.isEdit, tableId, reportId)"
      class="action-button action-button-edit"
      [attr.aria-label]="'Edit record ' + ((currentPage * pageSize) + rowIndex + 1)"
      tabindex="isEditIconVisible(row.isEdit, tableId, reportId) ? 0 : -1"
      edit-rid="${row.id}"
      [href]="getEditLink(row.id, tableId, reportId)"
      (click)="editRow($event, row.id, tableId, reportId)"
      (keydown.space)="$event.preventDefault(); editLink.click()"
    >
      Edit
    </a>

    <!-- Match -->
    <button
      *ngIf="isMatchIconVisible(reportId, tableId)"
      type="button"
      class="action-button action-button-match"
      [attr.aria-label]="'Match record ' + ((currentPage * pageSize) + rowIndex + 1)"
      matTooltip="Match to Parent Record"
      matTooltipPosition="right"
      view-rid="${row.id}"
      tabindex="isMatchIconVisible(reportId, tableId) ? 0 : -1"
      (click)="matchRecord(tableId, row.id, reportId)"
    >
      Match
    </button>

    <!-- Process -->
    <a
      #processLink
      *ngIf="isProcessIconVisible(getReportByKey(reportId).ProcedureKey, row.process_is_initiated, reportId)"
      class="action-button action-button-process"
      [attr.aria-label]="'View process state for record ' + ((currentPage * pageSize) + rowIndex + 1)"
      matTooltip="View Process State"
      matTooltipPosition="right"
      view-rid="${row.id}"
      tabindex="isProcessIconVisible(getReportByKey(reportId).ProcedureKey, row.process_is_initiated, reportId) ? 0 : -1"
      [routerLink]="getProcessState(row.id, tableId, reportId)"
      (keydown.space)="$event.preventDefault(); processLink.click()"
    >
      Process
    </a>

  </ng-template>

  <!-- Popup-specific template for small screen (plain anchors) -->
  <ng-template #popupActions let-row="row" let-rowIndex="rowIndex" let-currentPage="currentPage" let-pageSize="pageSize">
    <!-- View -->
    <ng-container *ngIf="isInViewMode; else viewModeTemplatePopup">
      <ng-container *ngIf="isProcessReport(reportId) && row.process_actor_ui_type == 1; else viewAsLinkPopup">
        <button
          *ngIf="isViewIconVisible(tableId)"
          type="button"
          class="popup-action-item popup-action-item-view"
          role="menuitem"
          [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
          view-rid="${row.id}"
          tabindex="isViewIconVisible(tableId) ? 0 : -1"
          (click)="viewRow($event, row, tableId, reportId)"
        >
          View
        </button>
      </ng-container>
      <ng-template #viewAsLinkPopup>
        <a
          #viewLinkPopup
          *ngIf="isViewIconVisible(tableId)"
          class="popup-action-item popup-action-item-view"
          role="menuitem"
          [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
          view-rid="${row.id}"
          tabindex="isViewIconVisible(tableId) ? 0 : -1"
          [routerLink]="getViewLink(row, tableId, reportId)"
          (keydown.space)="$event.preventDefault(); viewLinkPopup.click()"
        >
          View
        </a>
      </ng-template>
    </ng-container>

    <ng-template #viewModeTemplatePopup>
      <a
        #viewModeLinkPopup
        *ngIf="isViewIconVisible(tableId)"
        class="popup-action-item popup-action-item-view"
        role="menuitem"
        [attr.aria-label]="'View record ' + ((currentPage * pageSize) + rowIndex + 1)"
        view-rid="${row.id}"
        tabindex="isViewIconVisible(tableId) ? 0 : -1"
        [href]="getViewLink(row, tableId, reportId, false)"
        (click)="viewRow($event, row, tableId, reportId)"
        (keydown.space)="$event.preventDefault(); viewModeLinkPopup.click()"
      >
        View
      </a>
    </ng-template>

    <!-- Edit -->
    <a
      #editLinkPopup
      *ngIf="isEditIconVisible(row.isEdit, tableId, reportId)"
      class="popup-action-item popup-action-item-edit"
      role="menuitem"
      [attr.aria-label]="'Edit record ' + ((currentPage * pageSize) + rowIndex + 1)"
      tabindex="isEditIconVisible(row.isEdit, tableId, reportId) ? 0 : -1"
      edit-rid="${row.id}"
      [href]="getEditLink(row.id, tableId, reportId)"
      (click)="editRow($event, row.id, tableId, reportId)"
      (keydown.space)="$event.preventDefault(); editLinkPopup.click()"
    >
      Edit
    </a>

    <!-- Match -->
    <button
      *ngIf="isMatchIconVisible(reportId, tableId)"
      type="button"
      class="popup-action-item popup-action-item-match"
      role="menuitem"
      [attr.aria-label]="'Match record ' + ((currentPage * pageSize) + rowIndex + 1)"
      view-rid="${row.id}"
      tabindex="isMatchIconVisible(reportId, tableId) ? 0 : -1"
      (click)="matchRecord(tableId, row.id, reportId)"
    >
      Match
    </button>

    <!-- Process -->
    <a
      #processLinkPopup
      *ngIf="isProcessIconVisible(getReportByKey(reportId).ProcedureKey, row.process_is_initiated, reportId)"
      class="popup-action-item popup-action-item-process"
      role="menuitem"
      [attr.aria-label]="'View process state for record ' + ((currentPage * pageSize) + rowIndex + 1)"
      view-rid="${row.id}"
      tabindex="isProcessIconVisible(getReportByKey(reportId).ProcedureKey, row.process_is_initiated, reportId) ? 0 : -1"
      [routerLink]="getProcessState(row.id, tableId, reportId)"
      (keydown.space)="$event.preventDefault(); processLinkPopup.click()"
    >
      Process
    </a>
  </ng-template>

  <!-- Mobile actions menu for details view -->
  <app-actions-menu
    #actionsBoxRef
    [actionsButton]="popupActions"
    [row]="row"
    [enableAccessibility]="true"
    [rowIndex]="rowIndex"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [isCollapsed]="isActionsCollapsed(reportId)"
    popoverClass="actions-dropdown-popover"
  ></app-actions-menu>
</ng-template>

<!-- Optimized Embedded Report Section -->
<ng-template #embeddedReport let-preventFilter="preventFilter" let-trigger="trigger" let-isFormPrinting="isFormPrinting">
  <div class="records-main-inner mt-4">
    <ng-container *ngIf="relationTabs?.length && isReportVisible(reportDetails)">
      <div class="tabs-header tabs-header-custom-new custom-tab-header" style="max-width: 83.3vw;" #navRelationElement>
        <div class="scroll-arrow arrow arrow-left"  [ngStyle]="{
          'display': navRelationUlElement.scrollWidth < navRelationElement.scrollWidth ? 'none':''
          }"
        (keydown)="$event.preventDefault()"
        [ngClass]="navRelationUlElement.scrollLeft === 0 ? 'disabled-arrow':''"
        (click)="reportRecordService.scrollTabs('left',navRelationUlElement)"><div class="left-arrow"></div></div>
        <div class="nav-root-tabs-right" style="max-width: calc(100% - 123px);">
          <ul class="nav nav-tabs"  style="border-bottom: none;" #navRelationUlElement>
            <ng-container *ngFor="let tab of relationTabs; let i = index">
              <ng-container *ngIf="!reportDetails!.DetailsRelation[tab.Index].isReportInForm">
                <li [ngClass]="i === currentRelationTab ? 'active' : ''">
                  <a
                    class="tab-title custom-relation-title"
                    (click)="setCurrentRelationTab(i,tab.Index)"
                    data-toggle="tab"
                    [ngClass]="i === currentRelationTab ? 'active' : ''"
                    href="#tab{{ i }}"
                    >{{ tab.TableName }}<i class="icon-info custom-icon-size"
                    [title]="reportDetails!.DetailsRelation[tab.Index].EmbeddedSetting?.InfoText || ''"
                    *ngIf="reportDetails!.DetailsRelation[tab.Index].EmbeddedSetting?.AllowInfoText &&
                          reportDetails!.DetailsRelation[tab.Index].EmbeddedSetting?.InfoText"
                    ></i></a
                  >
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>
        <div class="scroll-arrow arrow arrow-right" [ngStyle]="{
          'display': navRelationUlElement.scrollWidth < navRelationElement.scrollWidth ? 'none':''
          }"
          [ngClass]="navRelationUlElement.scrollLeft+1.5 >= navRelationUlElement.scrollWidth-navRelationUlElement.clientWidth ? 'disabled-arrow':''"
          (keydown)="$event.preventDefault()"
          (click)="reportRecordService.scrollTabs('right',navRelationUlElement)"><div class="right-arrow"></div></div>
        <div ngbDropdown class="ml-auto btn-group-div btn-group justify-content-end"
            *ngIf="reportDetails!.DetailsRelation[relationTabs[currentRelationTab].Index].ReportType == 'datatable' ||
                  (reportDetails!.DetailsRelation[relationTabs[currentRelationTab].Index].ReportType == 'flex' &&
                    reportDetails!.DetailsRelation[relationTabs[currentRelationTab].Index].FlexReportType == 'grid'
                  ) || !relationTabs[currentRelationTab].ShowRelatedRecords
            ">
          <i
            class="material-icons material-icons-more_vert mr-4"
            style="font-size: 35px;"
            [ngStyle]="{
              color: 'black'
            }"
            ngbDropdownToggle
            id="dropdown2">
            </i>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdown2"
              class="dropdown-menu dropdown-menu-right dropdown-menu-container"
              style="max-height: calc(100vh - 100px); overflow: auto"
            >
              <ng-component
                *ngTemplateOutlet="dropMenu;context:{ report: reportDetails!.DetailsRelation[relationTabs[currentRelationTab].Index] }"
              ></ng-component>
            </div>
        </div>
      </div>
      <div class="tabs-conatent-main">
        <div class="tab-content edit-form form-view">
          <ng-container *ngFor="let tab of relationTabs; let j = index">
            <ng-container *ngIf="!reportDetails!.DetailsRelation[tab.Index].isReportInForm">
              <div
                id="tab{{ j }}"
                class="tab-pane fade"
                [ngClass]="(j === currentRelationTab || isFormPrinting) ? 'in active show' : ''"
              >
                <div class="records-main-inner">
                  <ng-container *ngIf="reportDetails!.DetailsRelation[tab.Index]?.EmbeddedSetting?.AllowMatchRecords">
                    <ng-container *ngTemplateOutlet="switchTemplate;context: { report: tab, inEmbeddedReport: true }"
                    ></ng-container>
                  </ng-container>
                  <ng-container *ngIf="tab.ShowRelatedRecords">
                    <ng-container *ngTemplateOutlet="reportWrapper;context: { report: reportDetails!.DetailsRelation[tab.Index], isInView: j === currentRelationTab || isFormPrinting, isFromForm: false, preventFilter: preventFilter, trigger: trigger, isFormPrinting: isFormPrinting }">
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!tab.ShowRelatedRecords">
                    <ng-container *ngTemplateOutlet="matchReport;context: { report: reportDetails!.DetailsRelation[tab.Index], isInView: j === currentRelationTab || isFormPrinting, isFromForm: false, preventFilter: preventFilter, trigger: trigger, relationTab: tab, isFormPrinting: isFormPrinting }">
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Optimized Tab Report Section -->
<ng-template #tabReportSection let-reportKey="reportKey" let-index="index" let-isFormPrinting="isFormPrinting" let-preventFilter="preventFilter" let-trigger="trigger">
  <div class="records-main-inner">
    <ng-container *ngIf="reports[reportKey]?.ShowRelatedRecords">
      <ng-container *ngTemplateOutlet="reportWrapper;context: { report: reports[reportKey], isInView: index === currentTabIndex || isFormPrinting, isFromForm: true, preventFilter: preventFilter, trigger: trigger, isFormPrinting: isFormPrinting }">
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!reports[reportKey]?.ShowRelatedRecords">
      <ng-container *ngTemplateOutlet="matchReport;context: { report: reports[reportKey], isInView: index === currentTabIndex || isFormPrinting, isFromForm: true, preventFilter: preventFilter, trigger: trigger, isFormPrinting: isFormPrinting }">
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- New Optimized Templates -->
<ng-template #reportHeader let-report="report" let-isFromForm="isFromForm">
  <div class="w-100 my-2 d-flex justify-content-between" [ngClass]="(hasDropdown(report) && !isFromForm) ? 'col-xs-12 print-header' : ''">
    <div [ngClass]="(hasDropdown(report) && !isFromForm) ? 'print-header' : ''">
      <h2>
        <a class="link-title-common-h2" [routerLink]="getReportLink(report)">
          {{ report.TableName }} <i class="icon-info custom-icon-size" [title]="report.EmbeddedSetting?.InfoText || ''" *ngIf="report.EmbeddedSetting?.AllowInfoText && report.EmbeddedSetting?.InfoText"></i>
        </a>
      </h2>
    </div>
    <div ngbDropdown *ngIf="hasDropdown(report) && isFromForm">
      <i class="material-icons material-icons-more_vert mr-4" style="font-size: 35px;" [ngStyle]="{ color: 'black' }" ngbDropdownToggle id="dropdown1"></i>
      <div ngbDropdownMenu aria-labelledby="dropdown1" class="dropdown-menu dropdown-menu-right dropdown-menu-container" style="max-height: calc(100vh - 100px); overflow: auto; top:50px; right:40px;">
        <ng-component *ngTemplateOutlet="dropMenu;context:{ report: report }"></ng-component>
      </div>
    </div>
  </div>
  <ng-container *ngIf="report?.EmbeddedSetting?.AllowMatchRecords && isFromForm">
    <ng-container
      *ngTemplateOutlet="switchTemplate;context: { report: report, inEmbeddedReport: false }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #reportWrapper let-report="report" let-isInView="isInView" let-isFromForm="isFromForm"  let-preventFilter="preventFilter" let-trigger="trigger" let-isFormPrinting="isFormPrinting" >
  <div class="records-main-inner-p-25" *ngIf="report.ReportType == null || report.ReportType == 'datatable'">
    <div class="col-xs-12 w-100 my-2">
      <ng-container *ngTemplateOutlet="reportHeader;context: { report: report, isFromForm: isFromForm }"></ng-container>
      <app-ngx-datatable *ngIf="showDatatables && (isInView || isFormPrinting)"
        [actions]="actions"
        [class]="'embedded-form-table'"
        [ngClass]="'embedded-form-table-'+report.ReportKey"
        [reportId]="report.ReportKey"
        [tableId]="report.TableKey"
        [referenceFieldId]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
        [lookupFieldValue]="report.ChildData?.LookupFieldValue || report.LookupFieldValue"
        [isEmbeddedReport]="true"
        [embeddedGroupColumn]="report.ReportGroupBy || ''"
        [dataset]="dataset[report.ReportKey]"
        [columns]="columns[report.ReportKey]"
        [preventFilter]="preventFilter"
        [fromRecordTable]="true"
        (payload)="payloadListener(report.TableKey, report.ReportKey, report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey, report.ChildData?.LookupFieldValue || report.LookupFieldValue, $event)"
        [trigger]="trigger"
        [isBulkUpdateEnable]="reportRecordService.isAdminOrSuperAdmin()"
        [isBulkDeleteEnable]="reportRecordService.isAdminOrSuperAdmin() || reportRecordService.isAuthorizedParticipant('deleteRecord', report.TableKey) && !report.ProcedureKey && !isProcessReport(report.ReportKey)"
        [allowInlineEdit]="report.AllowInlineEdit && (reportRecordService.isAdminOrSuperAdmin() || reportRecordService.isAuthorizedParticipant('editRecord', report.TableKey))"
        (onRecordDelete)="onTableUpdate($event)"
        (onRecordEdit)="onTableUpdate($event)"
        [isInView]="isInView || isFormPrinting"
        [printModeFromParent]="isFormPrinting"
        [isFromEmbeddedMainTabs]="true"
        [actionColumnWidth]="enableDataTableAccessibilityValue ? (isActionsCollapsed(report.ReportKey, false) ? 90 : getActionColumnWidth(report.ReportKey, false)) : (isActionsCollapsed(report.ReportKey, false) ? 70 : getActionColumnWidth(report.ReportKey, false))"
        [customCheckboxes]="enableDataTableAccessibilityValue"
        [customPagination]="enableDataTableAccessibilityValue"
        [isLightHeader]="enableDataTableAccessibilityValue">
      </app-ngx-datatable>
    </div>
  </div>
  <div class="overflow-color-change w-100 my-2" style="overflow-x: auto" *ngIf="report.ReportType && report.ReportType != 'datatable'">
    <ng-container *ngTemplateOutlet="reportHeader;context: { report: report, isFromForm: isFromForm }"></ng-container>
    <ng-container *ngIf="report.ReportType == 'flex'">
      <ng-container *ngIf="report.FlexReportType === 'chart'">
        <app-chart-view *ngIf="isInView"
          [tableId]="report.TableKey"
          [reportId]="report.ReportKey"
          [referenceFieldId]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
          [lookupFieldValue]="report.ChildData?.LookupFieldValue || report.LookupFieldValue"
          [isEmbeddedReport]="true"
          [isInView]="isInView || isFormPrinting">
        </app-chart-view>
        <div id="pivotContainer-{{ report.TableKey }}"></div>
      </ng-container>
      <ng-container *ngIf="report.FlexReportType === 'summary' || report.FlexReportType === 'grid'">
        <app-summary-view *ngIf="isInView"
          [tableId]="report.TableKey"
          [reportId]="report.ReportKey"
          [referenceFieldId]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
          [lookupFieldValue]="report.ChildData?.LookupFieldValue || report.LookupFieldValue"
          [isEmbeddedReport]="true"
          [isInView]="isInView || isFormPrinting">
        </app-summary-view>
        <div id="pivotContainer-{{ report.TableKey }}"></div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="report.ReportType == 'calendar'">
      <app-calendar-view *ngIf="isInView"
        [tableId]="report.TableKey"
        [reportId]="report.ReportKey"
        [referenceFieldKey]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
        [lookupFieldValue]="report.ChildData?.LookupFieldValue || recordId"
        [isEmbeddedReport]="true"
        (refreshReportDetails)="refreshReportDetails.emit()">
      </app-calendar-view>
      <div id="pivotContainer-{{ report.TableKey }}"></div>
    </ng-container>
    <ng-container *ngIf="report.ReportType == 'map'">
      <app-map-view *ngIf="isInView"
        [tableId]="report.TableKey"
        [reportId]="report.ReportKey"
        [referenceFieldKey]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
        [lookupfield]="recordId"
        [isEmbeddedReport]="true"
        (refreshReportDetails)="refreshReportDetails.emit()"
        [isInView]="isInView || isFormPrinting">
      </app-map-view>
      <div id="pivotContainer-{{ report.TableKey }}"></div>
    </ng-container>
    <ng-container *ngIf="report.ReportType == 'gantt'">
      <app-gantt-view *ngIf="isInView"
        [tableId]="report.TableKey"
        [reportId]="report.ReportKey"
        [referenceFieldKey]="report.ReferenceFieldKey"
        [lookupFieldValue]="recordId"
        [isEmbeddedReport]="true"
        [referenceFieldName]="report.ReferenceFieldFieldName"
        (refreshReportDetails)="refreshReportDetails.emit()">
      </app-gantt-view>
      <div id="pivotContainer-{{ report.TableKey }}"></div>
    </ng-container>
  </div>
</ng-template>

<ng-template #matchReport let-report="report" let-isInView="isInView" let-isFromForm="isFromForm" let-preventFilter="preventFilter" let-trigger="trigger" let-relationTab="relationTab" let-isFormPrinting="isFormPrinting">
  <div class="records-main-inner-p-25">
    <ng-container *ngTemplateOutlet="reportHeader;context: { report: report, isFromForm: isFromForm }"></ng-container>
    <app-ngx-datatable *ngIf="showDatatables && (isInView || isFormPrinting)"
      [actions]="actions"
      [class]="'embedded-form-table'"
      [ngClass]="'embedded-form-table-'+report.EmbeddedSetting?.MatchRecordsReportKey"
      [reportId]="report.EmbeddedSetting?.MatchRecordsReportKey || ''"
      [tableId]="report.TableKey"
      [embeddedTableName]="reportDetails!.TableName"
      [referenceFieldId]="report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey"
      [referenceFieldName]="report.ReferenceFieldFieldName || ''"
      [lookupFieldValue]="recordId"
      [isEmbeddedReport]="true"
      [embeddedGroupColumn]="report.ReportGroupBy || ''"
      [dataset]="dataset[report.EmbeddedSetting?.MatchRecordsReportKey || '']"
      [columns]="columns[report.EmbeddedSetting?.MatchRecordsReportKey || '']"
      [fromRecordTable]="true"
      (payload)="payloadListener(report.TableKey, report.EmbeddedSetting?.MatchRecordsReportKey, report.ChildData?.ReferenceFieldKey || report.ReferenceFieldKey, null, $event)"
      [trigger]="trigger"
      [isBulkUpdateEnable]="reportRecordService.isAdminOrSuperAdmin()"
      [isBulkDeleteEnable]="reportRecordService.isAdminOrSuperAdmin() || reportRecordService.isAuthorizedParticipant('deleteRecord', report.TableKey) && !report.ProcedureKey && !isProcessReport(report.ReportKey)"
      [allowInlineEdit]="report.EmbeddedSetting?.MatchRecordReportAllowInlineEdit && (reportRecordService.isAdminOrSuperAdmin() || reportRecordService.isAuthorizedParticipant('editRecord', report.TableKey))  || false"
      (onRecordDelete)="onTableUpdate($event)"
      (onRecordEdit)="onTableUpdate($event)"
      (embeddedMatched)="isFromForm ? (report.ShowRelatedRecords = true) : (relationTab.ShowRelatedRecords = true); refreshReportDetails.emit(true)"
      [isInView]="isInView || isFormPrinting"
      [printModeFromParent]="isFormPrinting"
      [isFromEmbeddedMainTabs]="true"
      [preventFilter]="preventFilter"
      [allowMatchRecords]="true"
      [actionColumnWidth]="enableDataTableAccessibilityValue ? (isActionsCollapsed(report.EmbeddedSetting?.MatchRecordsReportKey || '', true) ? 90 : getActionColumnWidth(report.EmbeddedSetting?.MatchRecordsReportKey || '', true)) : (isActionsCollapsed(report.EmbeddedSetting?.MatchRecordsReportKey || '', true) ? 70 : getActionColumnWidth(report.EmbeddedSetting?.MatchRecordsReportKey || '', true))"
      [customCheckboxes]="enableDataTableAccessibilityValue"
      [customPagination]="enableDataTableAccessibilityValue"
      [isLightHeader]="enableDataTableAccessibilityValue">
    </app-ngx-datatable>
  </div>
</ng-template>


<ng-template #dropMenu let-report="report">
  <ul>
    <li class="w-100"
    *ngIf="
        reportRecordService.isAdminOrSuperAdmin() ||
        reportRecordService.isAuthorizedParticipant('addRecord', report.TableKey)
      ">
      <span
      class="dot-dropdown-item mr-2"
      ngbDropdownItem
      (keydown)="$event.preventDefault()"
      (click)="openAddEditRelatedModal(report,'','',report.ReportKey)"
    >Add {{ getTableName(report) }}</span>
    </li>
    <li  class="w-100"
    *ngIf="
        reportRecordService.isAdminOrSuperAdmin() ||
        reportRecordService.isAuthorizedParticipant('editReport', report.TableKey)
      "
    >
      <span
      class="dot-dropdown-item mr-2"
      ngbDropdownItem
      (keydown)="$event.preventDefault()"
      (click)="redirectToEditReportForm(report,'editReport')"
    >Edit Report</span>
    </li>
    <li  class="w-100"
    *ngIf="
        reportRecordService.isAdminOrSuperAdmin() ||
        reportRecordService.isAuthorizedParticipant('editForm', report.TableKey)
      "
    >
      <span
      class="dot-dropdown-item mr-2"
      ngbDropdownItem
      (keydown)="$event.preventDefault()"
      (click)="redirectToEditReportForm(report, 'editForm')"
    >Edit Form</span>
    </li>
  </ul>
</ng-template>

<ng-template #switchTemplate let-report="report" let-inEmbeddedReport="inEmbeddedReport">
  <div class="toggle-wrapper" [ngClass]="inEmbeddedReport ? 'records-main-inner-p-25':''">
    <span class="toggle-label">Related {{ report.OriginalTableName }}</span>
    <app-checkbox type="toggle" class="custom-switch-toggle" [checked]="!report.ShowRelatedRecords" (change)="onToggleChange($event,report)"></app-checkbox>
    <span class="toggle-label">Unmatched {{ report.OriginalTableName }}</span>
  </div>
</ng-template>
